// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tete {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
}

/* background-color: #37bce1, #006080, #007399 */

.header {

    position: absolute;
    color: #ffffff;
    background-color: #007399;
    margin: 0;
    padding: 0;
    min-width: 320px;
    height: 85px;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
}

.menuBarSlider {
    height: "30px";
    margin-top: "80px"
}

.navbar {
    height: 87px;
    padding: 0;
    margin: 0;
}

#logo_mlakay {
    position: absolute;
    top: 1px;
    left: 30px;
    display: inline-table;
    list-style-type: none;
    text-decoration: none;
    color: white;
}


#logo_mlakay a {
    list-style-type: none;
    text-decoration: none;
    color: white;
}


.formElakaySearch {
    position: absolute;
    min-width: 240px;
    top: 12px;
    /* margin-bottom: 30px; */
    margin-left: 200px;
    margin-right: 70px;
    width: 51%;
    z-index: 10;
}

.elakay_search {
    padding-left: 15px;
    display: inline-flex;
    width: 100%;
    overflow: hidden;
    z-index: 10;

}

.elakay_input_search {
    float: left;
    width: 93%;

    padding: 2px 4px;
    background-color: rgba(256, 256, 256, 0.87);
    border-radius: 5px 0 0 5px;
    border: 0 none;
    outline: 0 none;
    font-size: 20px;
    color: #000;
}

.elakay_button_search {
    float: left;
    background-color: rgba(256, 256, 256, 0.7);
    border: 1px solid rgba(256, 256, 256, 0.7);
    border-radius: 0 5px 5px 0;
    color: #565656;
    padding: 7px 9px;
    min-width: 35px;
    max-width: 40px;

    cursor: pointer;
}

.loadind_search {
    position: relative;
    background-color: white;
    margin-left: 3%;
    color: #565656;
    width: 90%;
    z-index: 10;
}

.elakay_departement {
    text-decoration: none;
    position: absolute;
    display: inline-block;
    left: 15px;
    bottom: 3px;
}

.elakay_departement_name {
    /*background-color: #4CAF50;*/
    color: white;
    /*padding: 16px;*/
    font-size: 16px;
    border: none;
    cursor: pointer;
}

.elakay_departement:hover .elakay_departement_liste {
    display: block;
    width: 600px;
    left: 1000px;
}

.elakay_departement_liste {
    display: none;
    position: absolute;
    font-family: Verdana, Calibri, Sans-serif;
    background-color: #f9f9f9;
    /*min-width: 100px;*/
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.elakay_departement_liste a {
    color: black;
    padding: 32px 32px;
    text-decoration: none;
    display: block;

}

.elakay_departement_liste a:hover {
    background-color: #f1f1f1;
}

.elakay_liste_header {
    position: absolute;
    bottom: 3px;
    left: 175px;
    z-index: 2;
}

.elakay_liste_header ul {
    margin: 0px;
    padding: 0px;
    overflow: hidden;
}

.elakay_liste_header li {

    display: inline-block;
    line-height: 23px;
    /*font-family: 'Roboto', sans-serif;*/
    letter-spacing: 0;
    color: inherit;
    border: none;
    outline: none;
    font-size: 16px;
}

.me-l-1,
.me-l-2,
.me-l-3,
.me-l-4,
.me-l-5,
.me-l-6 {
    padding: 0 7px;
}

.elakay_liste_header a {
    color: #000;
}

.elakay_liste_header a {
    color: white;
    text-decoration: none;
}

.elakay_liste_header a:hover {
    color: red;
    text-decoration: none;
}

.user_elakay {
    text-align: center;
    display: inline-block;
    position: absolute;
    color: white;
    text-decoration: none;
    padding-left: 10px;
    padding-right: 10px;
    bottom: 3px;
    right: 150px;
}

.Langage_elakay {
    position: absolute;
    color: white;
    padding-left: 5px;
    padding-right: 5px;
    bottom: 3px;
    font-size: 16px;
    right: 320px;
    z-index: 910;
}

.user_elakay a {
    text-align: center;
    list-style-type: none;
    text-decoration: none;
    color: white;

}
.user_elakay :hover {
    text-align: center;
    list-style-type: none;
    text-decoration: none;
    color: red
}

.account_1 {
    text-decoration: none;
    list-style: none;
    position: absolute;
    display: inline-block;
    bottom: 3px;
    padding: 0;
    right: 130px;
}

.account_1:hover .account1_dc {
    display: block;
    width: 400px;
    right: -10px
}


.mlakay_shoppingcart {
    position: absolute;
    float: left;
    overflow: hidden;
    bottom: 3px;
    right: 48px;
    margin-left: 5px;

}

.mlakay_shoppingcart span {
    font-size: 28px;
    color: white;
    margin-top: 20px;
    padding-top: 30px;
    /*margin-bottom: 5px;*/
}

.mlakay_shoppingcart_name {
    display: inline-flex;
    overflow: hidden;
}

.elakay_departement_liste_r.is-open {
    transform: translateX(0);
    z-index: 1;
}

.account1_n {
    width: 50%;
    float: left;

}

#count {
    color: red;
    font-size: 16px;
}

@media only screen and (max-width: 1076px) {
    .user_elakay {
        display: none;
    }
    .Langage_elakay {
        position: absolute;
        color: white;
        padding-left: 5px;
        padding-right: 5px;
        bottom: 3px;
        font-size: 16px;
        right: 140px;
        z-index: 910;
    }

    #elakay_header {
        color: #ffffff;
        background-color: #007399;
        width: 100%;
        min-width: 853px;
        height: 85px;
        top: 0;
        left: 0;
        padding: 0;
    }

}


@media only screen and (max-width: 800px) {

    .header {
        width: 100%;
        height: 85px;
        position: fixed;
        color: #ffffff;
        background-color: #007399;
        margin: 0;
        padding: 0;
        top: 0;
        left: 0;
        right: 0;
        z-index: 900;
    }  
    


    .elakay_liste_header {
        top: 15px;
        left: 179px;
    }

    #elakay_header {
        color: #ffffff;
        background-color: #007399;
        min-width: 278px;
        height: 85px;
        top: 0;
        left: 0;
        padding: 0;
    }

    .formElakaySearch {
        position: absolute;
        top: 10px;
        margin-left: 40px;
        margin-top: 36px;
        z-index: 10;
        width: 80%;
    }


    .mlakay_input_search {
        display: inline-flex;
        width: 100%;
        height: 30PX;

    }

    #logo_mlakay a h1 {
        margin-top: 1px;
        left: 20px;

    }

    .mlakay_shoppingcart {
        position: absolute;
        float: left;
        overflow: hidden;
        top: 1px;
        right: 12px;
        margin-left: 5px;

    }

    .mlakay_shoppingcart span {
        font-size: 30px;
        color: white;
        margin-top: 1px;
        /*margin-bottom: 5px;*/
    }

    .Langage_elakay {
        position: absolute;
        color: white;
        padding-left: 5px;
        padding-right: 5px;
        bottom: 3px;
        font-size: 16px;
        right: 5px;
        z-index: 910;
    }

    .elakay_departement_r {
        display: inline-block;
        color: white;
        left: 0px;
        top: 1px;
        margin-top: 1px;
    }

    .munus_mobile {
        display: inline-block;
    }

    .icon {
        display: block;
        font-size: 29px;
        color: white;
        margin-left: 28px;
        right: 10px;
        cursor: pointer;
    }

    .icon a {
        color: white;
    }

    .elakay_departement_liste_r {
        position: absolute;
        display: block;
        left: -1px;
        background-color: #007399;
        /*min-width: 890px;*/
        top: 44px;
        width: 200px;
        height: 853px;
        /*bottom: 0;*/
        transform: translateX(-100%);
        transition: all 0.3S ease-in-out;
    }

}


@media only screen and (max-width: 700px) {
    .me-l-2 {
        display: none;
    }

    .me-l-4 {
        padding: 0;
    }


    .header {
        width: 100%;
        position: fixed;
        color: #ffffff;
        background-color: #007399;
        margin: 0;
        padding: 0;
        min-width: 320px;
        height: 85px;
        top: 0;
        left: 0;
        z-index: 900;
    }

    #elakay_header {
        color: #ffffff;
        background-color: #007399;
        width: 100%;
        min-width: 700px;
        height: 85px;
        top: 0;
        left: 0;
        padding: 0;
    }
    .Langage_elakay {
        position: absolute;
        color: white;
        padding-left: 5px;
        padding-right: 5px;
        top: 15px; 
        font-size: 16px;
        right: 100px;
         z-index: 910;
    }
}


@media only screen and (max-width: 576px) {
    .elakay_liste_header {
        display: none;
    }

    .header {
        width: 100%;
        position: fixed;
        color: #ffffff;
        background-color: #007399;
        margin: 0;
        padding: 0;
        min-width: 320px;
        height: 85px;
        top: 0;
        left: 0;
        z-index: 900;
    }

}`, "",{"version":3,"sources":["webpack://./src/includes/Layout/Header.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA,gDAAgD;;AAEhD;;IAEI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;AAChB;;;AAGA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,UAAU;;IAEV,gBAAgB;IAChB,2CAA2C;IAC3C,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,0CAA0C;IAC1C,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;;IAEf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,UAAU;IACV,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,oBAAoB;IACpB,+CAA+C;IAC/C,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;;AAElB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;;;;;;IAMI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;;AAEhB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ;AACJ;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;;AAEf;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,UAAU;IACd;;AAEJ;;;AAGA;;IAEI;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,SAAS;QACT,UAAU;QACV,MAAM;QACN,OAAO;QACP,QAAQ;QACR,YAAY;IAChB;;;;IAIA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,UAAU;IACd;;;IAGA;QACI,oBAAoB;QACpB,WAAW;QACX,YAAY;;IAEhB;;IAEA;QACI,eAAe;QACf,UAAU;;IAEd;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;QAChB,QAAQ;QACR,WAAW;QACX,gBAAgB;;IAEpB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,SAAS;QACT,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,UAAU;QACV,yBAAyB;QACzB,oBAAoB;QACpB,SAAS;QACT,YAAY;QACZ,aAAa;QACb,aAAa;QACb,4BAA4B;QAC5B,gCAAgC;IACpC;;AAEJ;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;;IAGA;QACI,WAAW;QACX,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,SAAS;QACT,UAAU;QACV,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,YAAY;SACX,YAAY;IACjB;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,SAAS;QACT,UAAU;QACV,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,OAAO;QACP,YAAY;IAChB;;AAEJ","sourcesContent":[".tete {\n    position: absolute;\n    width: 100%;\n    top: 0;\n    left: 0;\n}\n\n/* background-color: #37bce1, #006080, #007399 */\n\n.header {\n\n    position: absolute;\n    color: #ffffff;\n    background-color: #007399;\n    margin: 0;\n    padding: 0;\n    min-width: 320px;\n    height: 85px;\n    top: 0;\n    left: 0;\n    z-index: 9;\n    width: 100%;\n}\n\n.menuBarSlider {\n    height: \"30px\";\n    margin-top: \"80px\"\n}\n\n.navbar {\n    height: 87px;\n    padding: 0;\n    margin: 0;\n}\n\n#logo_mlakay {\n    position: absolute;\n    top: 1px;\n    left: 30px;\n    display: inline-table;\n    list-style-type: none;\n    text-decoration: none;\n    color: white;\n}\n\n\n#logo_mlakay a {\n    list-style-type: none;\n    text-decoration: none;\n    color: white;\n}\n\n\n.formElakaySearch {\n    position: absolute;\n    min-width: 240px;\n    top: 12px;\n    /* margin-bottom: 30px; */\n    margin-left: 200px;\n    margin-right: 70px;\n    width: 51%;\n    z-index: 10;\n}\n\n.elakay_search {\n    padding-left: 15px;\n    display: inline-flex;\n    width: 100%;\n    overflow: hidden;\n    z-index: 10;\n\n}\n\n.elakay_input_search {\n    float: left;\n    width: 93%;\n\n    padding: 2px 4px;\n    background-color: rgba(256, 256, 256, 0.87);\n    border-radius: 5px 0 0 5px;\n    border: 0 none;\n    outline: 0 none;\n    font-size: 20px;\n    color: #000;\n}\n\n.elakay_button_search {\n    float: left;\n    background-color: rgba(256, 256, 256, 0.7);\n    border: 1px solid rgba(256, 256, 256, 0.7);\n    border-radius: 0 5px 5px 0;\n    color: #565656;\n    padding: 7px 9px;\n    min-width: 35px;\n    max-width: 40px;\n\n    cursor: pointer;\n}\n\n.loadind_search {\n    position: relative;\n    background-color: white;\n    margin-left: 3%;\n    color: #565656;\n    width: 90%;\n    z-index: 10;\n}\n\n.elakay_departement {\n    text-decoration: none;\n    position: absolute;\n    display: inline-block;\n    left: 15px;\n    bottom: 3px;\n}\n\n.elakay_departement_name {\n    /*background-color: #4CAF50;*/\n    color: white;\n    /*padding: 16px;*/\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n}\n\n.elakay_departement:hover .elakay_departement_liste {\n    display: block;\n    width: 600px;\n    left: 1000px;\n}\n\n.elakay_departement_liste {\n    display: none;\n    position: absolute;\n    font-family: Verdana, Calibri, Sans-serif;\n    background-color: #f9f9f9;\n    /*min-width: 100px;*/\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 1;\n}\n\n.elakay_departement_liste a {\n    color: black;\n    padding: 32px 32px;\n    text-decoration: none;\n    display: block;\n\n}\n\n.elakay_departement_liste a:hover {\n    background-color: #f1f1f1;\n}\n\n.elakay_liste_header {\n    position: absolute;\n    bottom: 3px;\n    left: 175px;\n    z-index: 2;\n}\n\n.elakay_liste_header ul {\n    margin: 0px;\n    padding: 0px;\n    overflow: hidden;\n}\n\n.elakay_liste_header li {\n\n    display: inline-block;\n    line-height: 23px;\n    /*font-family: 'Roboto', sans-serif;*/\n    letter-spacing: 0;\n    color: inherit;\n    border: none;\n    outline: none;\n    font-size: 16px;\n}\n\n.me-l-1,\n.me-l-2,\n.me-l-3,\n.me-l-4,\n.me-l-5,\n.me-l-6 {\n    padding: 0 7px;\n}\n\n.elakay_liste_header a {\n    color: #000;\n}\n\n.elakay_liste_header a {\n    color: white;\n    text-decoration: none;\n}\n\n.elakay_liste_header a:hover {\n    color: red;\n    text-decoration: none;\n}\n\n.user_elakay {\n    text-align: center;\n    display: inline-block;\n    position: absolute;\n    color: white;\n    text-decoration: none;\n    padding-left: 10px;\n    padding-right: 10px;\n    bottom: 3px;\n    right: 150px;\n}\n\n.Langage_elakay {\n    position: absolute;\n    color: white;\n    padding-left: 5px;\n    padding-right: 5px;\n    bottom: 3px;\n    font-size: 16px;\n    right: 320px;\n    z-index: 910;\n}\n\n.user_elakay a {\n    text-align: center;\n    list-style-type: none;\n    text-decoration: none;\n    color: white;\n\n}\n.user_elakay :hover {\n    text-align: center;\n    list-style-type: none;\n    text-decoration: none;\n    color: red\n}\n\n.account_1 {\n    text-decoration: none;\n    list-style: none;\n    position: absolute;\n    display: inline-block;\n    bottom: 3px;\n    padding: 0;\n    right: 130px;\n}\n\n.account_1:hover .account1_dc {\n    display: block;\n    width: 400px;\n    right: -10px\n}\n\n\n.mlakay_shoppingcart {\n    position: absolute;\n    float: left;\n    overflow: hidden;\n    bottom: 3px;\n    right: 48px;\n    margin-left: 5px;\n\n}\n\n.mlakay_shoppingcart span {\n    font-size: 28px;\n    color: white;\n    margin-top: 20px;\n    padding-top: 30px;\n    /*margin-bottom: 5px;*/\n}\n\n.mlakay_shoppingcart_name {\n    display: inline-flex;\n    overflow: hidden;\n}\n\n.elakay_departement_liste_r.is-open {\n    transform: translateX(0);\n    z-index: 1;\n}\n\n.account1_n {\n    width: 50%;\n    float: left;\n\n}\n\n#count {\n    color: red;\n    font-size: 16px;\n}\n\n@media only screen and (max-width: 1076px) {\n    .user_elakay {\n        display: none;\n    }\n    .Langage_elakay {\n        position: absolute;\n        color: white;\n        padding-left: 5px;\n        padding-right: 5px;\n        bottom: 3px;\n        font-size: 16px;\n        right: 140px;\n        z-index: 910;\n    }\n\n    #elakay_header {\n        color: #ffffff;\n        background-color: #007399;\n        width: 100%;\n        min-width: 853px;\n        height: 85px;\n        top: 0;\n        left: 0;\n        padding: 0;\n    }\n\n}\n\n\n@media only screen and (max-width: 800px) {\n\n    .header {\n        width: 100%;\n        height: 85px;\n        position: fixed;\n        color: #ffffff;\n        background-color: #007399;\n        margin: 0;\n        padding: 0;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 900;\n    }  \n    \n\n\n    .elakay_liste_header {\n        top: 15px;\n        left: 179px;\n    }\n\n    #elakay_header {\n        color: #ffffff;\n        background-color: #007399;\n        min-width: 278px;\n        height: 85px;\n        top: 0;\n        left: 0;\n        padding: 0;\n    }\n\n    .formElakaySearch {\n        position: absolute;\n        top: 10px;\n        margin-left: 40px;\n        margin-top: 36px;\n        z-index: 10;\n        width: 80%;\n    }\n\n\n    .mlakay_input_search {\n        display: inline-flex;\n        width: 100%;\n        height: 30PX;\n\n    }\n\n    #logo_mlakay a h1 {\n        margin-top: 1px;\n        left: 20px;\n\n    }\n\n    .mlakay_shoppingcart {\n        position: absolute;\n        float: left;\n        overflow: hidden;\n        top: 1px;\n        right: 12px;\n        margin-left: 5px;\n\n    }\n\n    .mlakay_shoppingcart span {\n        font-size: 30px;\n        color: white;\n        margin-top: 1px;\n        /*margin-bottom: 5px;*/\n    }\n\n    .Langage_elakay {\n        position: absolute;\n        color: white;\n        padding-left: 5px;\n        padding-right: 5px;\n        bottom: 3px;\n        font-size: 16px;\n        right: 5px;\n        z-index: 910;\n    }\n\n    .elakay_departement_r {\n        display: inline-block;\n        color: white;\n        left: 0px;\n        top: 1px;\n        margin-top: 1px;\n    }\n\n    .munus_mobile {\n        display: inline-block;\n    }\n\n    .icon {\n        display: block;\n        font-size: 29px;\n        color: white;\n        margin-left: 28px;\n        right: 10px;\n        cursor: pointer;\n    }\n\n    .icon a {\n        color: white;\n    }\n\n    .elakay_departement_liste_r {\n        position: absolute;\n        display: block;\n        left: -1px;\n        background-color: #007399;\n        /*min-width: 890px;*/\n        top: 44px;\n        width: 200px;\n        height: 853px;\n        /*bottom: 0;*/\n        transform: translateX(-100%);\n        transition: all 0.3S ease-in-out;\n    }\n\n}\n\n\n@media only screen and (max-width: 700px) {\n    .me-l-2 {\n        display: none;\n    }\n\n    .me-l-4 {\n        padding: 0;\n    }\n\n\n    .header {\n        width: 100%;\n        position: fixed;\n        color: #ffffff;\n        background-color: #007399;\n        margin: 0;\n        padding: 0;\n        min-width: 320px;\n        height: 85px;\n        top: 0;\n        left: 0;\n        z-index: 900;\n    }\n\n    #elakay_header {\n        color: #ffffff;\n        background-color: #007399;\n        width: 100%;\n        min-width: 700px;\n        height: 85px;\n        top: 0;\n        left: 0;\n        padding: 0;\n    }\n    .Langage_elakay {\n        position: absolute;\n        color: white;\n        padding-left: 5px;\n        padding-right: 5px;\n        top: 15px; \n        font-size: 16px;\n        right: 100px;\n         z-index: 910;\n    }\n}\n\n\n@media only screen and (max-width: 576px) {\n    .elakay_liste_header {\n        display: none;\n    }\n\n    .header {\n        width: 100%;\n        position: fixed;\n        color: #ffffff;\n        background-color: #007399;\n        margin: 0;\n        padding: 0;\n        min-width: 320px;\n        height: 85px;\n        top: 0;\n        left: 0;\n        z-index: 900;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
